/* eslint-disable arrow-body-style */
import _ from 'underscore';

export const getDescriptionStyles = ({ styleOverrides }) => () => {
  return {
    description: _.extend({
    }, styleOverrides.description),
    descriptionParent: _.extend({
    }, styleOverrides.descriptionParent),
  };
};
